
import { IGlobalState } from "@/store";
import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  ref,
  toRefs,
} from "vue";
import { ElMessage } from "element-plus";
import { uploadFile } from "@/utils/aliOss";
import { useStore } from "vuex";
import { saveUserDetail } from "@/service/api";
import { validateInfoCode } from "@/utils/validate";
import AREA_TYPE, { IAreaItem } from "@/typings/area";
import { useAreaList, setCurrentAreaItem } from "@/hooks/area";

export default defineComponent({
  setup() {
    const store = useStore<IGlobalState>();
    const fileInput = ref<any>(null);

    const state = reactive({
      type: 1,
      formItem: {
        id: "",
        enterpriseFullName: "",
        enterpriseShortName: "",
        unifiedSocialCreditCode: "",
        provinceId: "",
        provinceName: "",
        cityId: "",
        cityName: "",
        districtId: "",
        districtName: "",
        businessLicense: "",
      },
      rules: {
        enterpriseFullName: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        enterpriseShortName: [
          { required: true, message: "请输入公司简称", trigger: "blur" },
        ],
        unifiedSocialCreditCode: [
          { required: true, message: "请输入统一社会信用码", trigger: "blur" },
          { validator: validateInfoCode, trigger: "blur" },
        ],
        districtId: [
          { required: true, message: "请选择地区", trigger: "change" },
        ],
      },
    });
    const formItemRef = ref<any>(null);
    // 省
    const provinceId = computed({
      get: () => store.state.area.provinceId,
      set: (val) => {
        store.state.area.provinceId = val;
      },
    });

    // 市
    const cityId = computed({
      get: () => store.state.area.cityId,
      set: (val) => {
        store.state.area.cityId = val;
      },
    });

    // 区
    const districtId = computed({
      get: () => store.state.area.districtId,
      set: (val) => {
        store.state.area.districtId = val;
      },
    });

    const provinces = computed(() => store.state.area.provinces);
    const citys = computed(() => store.state.area.citys);
    const districts = computed(() => store.state.area.districts);
    /**
     * 获取区域列表
     */
    const getAreaData = async () => {
      await useAreaList(
        store,
        state.type,
        state.type === AREA_TYPE.PROVINCE_TYPE
          ? ""
          : state.type === AREA_TYPE.CITY_TYPE
          ? provinceId.value
          : cityId.value
      );
    };
    /**
     * 根据省市区 id获取省市区对应名称
     */
    function findAreaNameById(id: string, type: AREA_TYPE) {
      let sourceArr: IAreaItem[] = [];
      if (type === AREA_TYPE.PROVINCE_TYPE) {
        sourceArr = provinces.value;
      } else if (type === AREA_TYPE.CITY_TYPE) {
        sourceArr = citys.value;
      } else if (type === AREA_TYPE.DISTRICT_TYPE)  {
        sourceArr = districts.value;
      }
      const curAreaItem: IAreaItem[] = sourceArr.filter(
        (item) => item.id === id
      );
      return curAreaItem[0];
    }
    /**
     * 改变省市区
     */
    async function onProvinceChange(id: string, type: AREA_TYPE) {
      if (type === AREA_TYPE.PROVINCE_TYPE) {
        state.type = AREA_TYPE.CITY_TYPE;
      } else if (type === AREA_TYPE.CITY_TYPE) {
        state.type = AREA_TYPE.DISTRICT_TYPE;
      }
      if (type < 3) {
        await getAreaData();
      }
      const curAreaItem = findAreaNameById(id, type);
      await setCurrentAreaItem(store, type, curAreaItem);
    }
    /**
     * 点击上传图片来触发上传文件的input
     */
    function uploadImgClick() {
      document.getElementById("uploadImg")!.click();
    }
    function imgToUpload(e: any) {
      //获取文件信息
      const fileList: Array<File> = [...e.currentTarget.files];
      if (fileList) {
        for (let i = 0; i < fileList.length; i++) {
          const file = fileList[i];
          const fileName: string = file.name;
          const fileExt: string = fileName.substring(
            fileName.lastIndexOf(".") + 1,
            fileName.length
          );
          const maxSize: number = 5 * 1024 * 1024;
          if (file.size > maxSize) {
            ElMessage({
              message: "请上传文件大小不超过5MB的图片！",
              type: "error",
            });
            return;
          }
          console.log(fileExt);
          if (
            fileExt != "jpg" &&
            fileExt != "jpeg" &&
            fileExt != "bmp" &&
            fileExt != "png"
          ) {
            ElMessage({
              message: "请上传jpg、jpeg、bmp、png格式图片！",
              type: "error",
            });
            return;
          }

          uploadFile(
            file,
            "openapi/license",
            "",
            "",
            (uploadState: boolean, filepath: string) => {
              if (uploadState) {
                state.formItem.businessLicense =
                  store.state.app.aliyunPath + "/" + filepath;
                fileInput.value.value = "";
              }
            }
          );
        }
      }
    }
    /**
     * 删除应用图标
     */
    function clearnImg() {
      state.formItem.businessLicense = "";
    }
    /**
     * 初始化企业信息
     */
    async function initFactoryInfo() {
      state.formItem.id = store.state.user.id;
      state.formItem.enterpriseFullName = store.state.user.enterpriseFullName;
      state.formItem.enterpriseShortName = store.state.user.enterpriseShortName;
      state.formItem.unifiedSocialCreditCode =
        store.state.user.unifiedSocialCreditCode;
      state.formItem.provinceId = store.state.user.provinceId;
      provinceId.value = store.state.user.provinceId;
      await onProvinceChange(store.state.user.provinceId, 1);
      state.formItem.provinceName = store.state.user.provinceName;
      state.formItem.cityId = store.state.user.cityId;
      cityId.value = store.state.user.cityId;
      await onProvinceChange(store.state.user.cityId, 2);
      state.formItem.cityName = store.state.user.cityName;
      state.formItem.districtId = store.state.user.districtId;
      districtId.value = store.state.user.districtId;
      await onProvinceChange(store.state.user.districtId, 3);
      state.formItem.districtName = store.state.user.districtName;
      state.formItem.businessLicense = store.state.user.businessLicense;
    }
    /**
     * 点击保存
     */
    async function saveFactoryInfo() {
      formItemRef.value.validate(async (valid: boolean) => {
        if (valid) {
          const params = {
            id: state.formItem.id,
            enterpriseFullName: state.formItem.enterpriseFullName,
            enterpriseShortName: state.formItem.enterpriseShortName,
            businessLicense: state.formItem.businessLicense,
            unifiedSocialCreditCode: state.formItem.unifiedSocialCreditCode,
            provinceId: provinceId.value,
            provinceName: findAreaNameById(
              provinceId.value,
              AREA_TYPE.PROVINCE_TYPE
            ).areaName,
            cityId: cityId.value,
            cityName: "",
            districtId: districtId.value,
            districtName: "",
          };

          if (cityId.value) {
            params.cityName = findAreaNameById(
              cityId.value,
              AREA_TYPE.CITY_TYPE
            ).areaName;
          }
          if (districtId.value) {
            params.districtName = findAreaNameById(
              districtId.value,
              AREA_TYPE.DISTRICT_TYPE
            ).areaName;
          }

          if (state.formItem.businessLicense == "") {
            ElMessage({ message: "请上传营业执照！", type: "error" });
            return;
          }
          const result = await saveUserDetail(params);
          console.log(result);
          if (result.code == 1) {
            ElMessage({ message: "修改成功！", type: "success" });
          } else {
            ElMessage({ message: result.msg, type: "error" });
          }
        } else {
          return false;
        }
      });
    }
    /**
     * 页面一开始加载
     */
    onMounted(async () => {
      await getAreaData();
      // 初始化企业信息
      initFactoryInfo();
    });
    return {
      ...toRefs(state),
      formItemRef,
      provinces,
      citys,
      districts,
      provinceId,
      cityId,
      districtId,
      uploadImgClick,
      imgToUpload,
      clearnImg,
      saveFactoryInfo,
      onProvinceChange,
      fileInput,
    };
  },
});
